/** Every board of the admin, area by area (dev navigator, smoke test, layout audit, placeholders). */
import { authBoards } from "@/areas/auth/boards";
import { creationBoards } from "@/areas/creation/boards";
import { clientsBoards } from "@/areas/clients/boards";
import { operationsBoards } from "@/areas/operations/boards";
import { communicationBoards } from "@/areas/communication/boards";
import { financeBoards } from "@/areas/finance/boards";
import { accessBoards } from "@/areas/access/boards";
import { saasBoards } from "@/areas/saas/boards";
import { techBoards } from "@/areas/tech/boards";
import type { BoardDef } from "./types";

export const BOARDS: BoardDef[] = [
  ...authBoards,
  ...creationBoards,
  ...clientsBoards,
  ...operationsBoards,
  ...communicationBoards,
  ...financeBoards,
  ...accessBoards,
  ...saasBoards,
  ...techBoards,
];

export const boardById = (id: string) => BOARDS.find((b) => b.id === id);
export const boardsAtPath = (path: string) => BOARDS.filter((b) => b.path === path);
